(() => {
  const root = () => (window.Shopify?.routes?.root || '/');
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const onCartPage = () => /\/cart\/?$/.test(location.pathname);
  let lastFocus = null;
  const setCount = n => document.querySelectorAll('.bag > span:not(.sr-only)').forEach(el => { el.textContent = '(' + n + ')'; });
  async function refresh() {
    const d = drawer();
    if (!d) return;
    const res = await fetch(root() + '?sections=cart-drawer', { headers: { Accept: 'application/json' } });
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data['cart-drawer'] || '', 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer-inner]');
    const current = d.querySelector('[data-cart-drawer-inner]');
    if (fresh && current) { current.replaceWith(fresh); setCount(fresh.dataset.count || 0); }
  }
  function show() {
    const d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
    document.documentElement.classList.add('cart-drawer-lock');
    d.querySelector('.cart-drawer-panel')?.focus({ preventScroll: true });
  }
  function hide() {
    const d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-lock');
    setTimeout(() => { if (!d.classList.contains('is-open')) d.hidden = true; }, 360);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  async function open() {
    if (!drawer()) { location.href = root() + 'cart'; return; }
    try { await refresh(); } catch {}
    show();
  }
  async function post(url, body) {
    const d = drawer();
    d?.classList.add('is-busy');
    try {
      const res = await fetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Something went wrong. Please try again.');
      await refresh();
    } catch (error) {
      try { await refresh(); } catch {}
      const msg = drawer()?.querySelector('[data-cart-error]');
      if (msg) msg.textContent = error.message;
    } finally {
      d?.classList.remove('is-busy');
    }
  }
  window.PotencyCart = { open, refresh, close: hide };
  document.addEventListener('click', event => {
    const t = event.target;
    if (!t.closest) return;
    if (t.closest('[data-cart-close]')) { event.preventDefault(); hide(); return; }
    const bag = t.closest('a.bag');
    if (bag && drawer() && !onCartPage() && !event.metaKey && !event.ctrlKey && !event.shiftKey) { event.preventDefault(); open(); return; }
    const qty = t.closest('[data-cd-qty]');
    if (qty) { event.preventDefault(); post('cart/change.js', { line: Number(qty.dataset.line), quantity: Math.max(0, Number(qty.dataset.cdQty)) }); return; }
    const add = t.closest('[data-cd-add]');
    if (add) { event.preventDefault(); add.disabled = true; add.textContent = 'Adding…'; post('cart/add.js', { items: [{ id: Number(add.dataset.cdAdd), quantity: 1 }] }); }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  // Header: hide while scrolling down, show again on any scroll up.
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const dy = y - lastY;
    if (Math.abs(dy) < 6) return;
    const navOpen = document.querySelector('.mobile-nav[open]');
    document.documentElement.classList.toggle('hdr-hide', dy > 0 && y > 260 && !navOpen);
    lastY = y;
  }, { passive: true });
})();
